import { ItemButton } from '../JRCTabs/JRCTabs';
import styled from 'styled-components';
import { JRCH2 } from '../JRCTypo/JRCTypo';
import { JRCIconButton } from '../JRCIconButton/JRCIconButton';
import { CONTAINER_PADDING } from 'components/JRCAppContainer/JRCAppContainer';

export const JRCAppLeftColumnWrapperTop = styled.div`
    display: flex;
    flex-direction: row;
    align-items: baseline;
`;

export const ColumnRelativeWrapper = styled.div<{ isMinimized: boolean }>`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    min-width: ${(props) => (props.isMinimized ? '80px' : '300px')};
    max-width: ${(props) => (props.isMinimized ? '80px' : '300px')};
`;

export const ColumnRelativeSticky = styled.div<{ isMinimized: boolean; isClosed: boolean }>`
    display: flex;
    position: sticky;
    bottom: 0;
    min-height: calc(var(--body-height) - ${CONTAINER_PADDING * 2}px);
    background: ${(props) => props.theme.color.grey0};
    min-width: ${(props) => (props.isMinimized ? '80px' : '300px')};
    overflow: ${(props) => (props.isClosed ? 'visible' : 'hidden')};
`;

export const ColumnRelativeTransition = styled.div<{ isMinimized: boolean }>`
    display: flex;
    flex-direction: row;
    width: ${(props) => (props.isMinimized ? '0px' : '380px')};
    margin-left: ${(props) => (props.isMinimized ? '0px' : '-80px')};
    transition: all 0.4s;
`;

export const ColumnAppDefault = styled.div<{ isMinimized: boolean; isClosed: boolean }>`
    display: ${(props) => (props.isClosed ? 'none' : 'flex')};
    flex-direction: column;
    gap: 32px;
    display: ${(props) => (props.isClosed ? 'hidden' : 'visible')};
    position: relative;
    box-sizing: border-box;
    min-width: 300px;
    max-width: 300px;

    padding: 35px;
`;

export const ColumnAppMinimize = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    min-width: 80px;
    max-width: 80px;
    box-sizing: border-box;

    padding: 35px 18px;
`;

export const MenuWrapper = styled.div<{ isMinimized: boolean }>`
    transition: ${(props) => (props.isMinimized ? 'opacity .6s .3s' : 'opacity .6s .8s')};
    opacity: ${(props) => (props.isMinimized ? '0' : '1')};
`;

export const ItemsIcon = styled(ItemButton)`
    display: flex;
    margin-top: 5px;
    margin-bottom: 5px;
    background-color: ${(props) => props.theme.color.grey0};
    transition: 0.3s;
    &:hover,
    &:focus-within {
        background-color: ${(props) => props.theme.color.grey0};
        color: ${(props) => props.theme.color.grey5};
        margin-top: 10px;
        margin-bottom: 10px;
        transform: scale(1.2);
    }
`;

export const TitleMenu = styled(JRCH2)`
    font-weight: ${(props) => props.theme.font.weight.medium};
    font-size: 12px;
    margin-bottom: 5px;
    text-transform: uppercase;
`;

export const JRCIconButtonAppLeftColumn = styled(JRCIconButton)`
    background-color: ${(props) => props.theme.color.grey0};
    transition: 0.3s;
    &:hover,
    :focus {
        box-shadow: 2px 2px 4px 0px ${(props) => props.theme.color.grey3};
        background-color: ${(props) => props.theme.color.white};
    }
`;

export const AppLeftColumnIconWrapper = styled.ul<{ isMinimized: boolean }>`
    list-style-type: none;
    margin-top: 32px;
    transition: ${(props) => (props.isMinimized ? 'opacity .6s' : 'opacity .6s .3s')};
    opacity: ${(props) => (props.isMinimized ? '1' : '0')};
`;

export const AbsoluteContainer = styled.div`
    position: absolute;
    right: 8px;
    margin: auto;
`;
export const AbsoluteContainerMinimized = styled.div<{ isMinimized: boolean }>`
    position: absolute;
    top: 43px;
    right: -8px;
    transition: all 0.4s;
    opacity: ${(props) => (props.isMinimized ? '1' : '0')};
`;
export const SectionMinimizesWrapper = styled.div`
    margin-bottom: 20px;
`;
